import { render, staticRenderFns } from "./defRegister.vue?vue&type=template&id=1438a701&"
import script from "./defRegister.vue?vue&type=script&lang=js&"
export * from "./defRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports